// @ts-check
import React from 'react'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{loading?: boolean, isSmall?: boolean, className?: string }} props
 */
const Spinner = ({ loading, isSmall = false, className }) =>
  loading ? (
    <div className={cn(styles.spinner, className, { [styles.small]: isSmall })}>
      <div className={styles.first} />
      <div className={styles.second} />
      <div className={styles.third} />
    </div>
  ) : null

Spinner.defaultProps = { loading: true }

export { Spinner }
